import { Injectable } from "@angular/core";
import { ProjectStatusDto } from "@domain/project/template/property/project/details/information/project-status.dto";

@Injectable({
  providedIn: "root",
})
export class ProjectStatusIconMapperService {
  mapIcon(status: string | undefined, statuses: ProjectStatusDto[]): string {
    if (statuses.length === 0) {
      console.warn("statuses not loaded");
    }
    const projectStatus: ProjectStatusDto | undefined = statuses.find((s) => {
      return s.text === status;
    });
    if (projectStatus) {
      return projectStatus.icon;
    }
    return "";
  }
}
